<template>
  <div class="electiveOperation">
    <div class="nav">
      <div class="title">
        <i class="iconfont icon-yuyue"></i>
        <p>手术预约</p>
      </div>
      <div class="line"></div>
      <div class="main">
        <el-form :inline="true" :model="appointment" class="demo-form-inline">
          <el-col :span="8">
            <el-form-item label="手术名称">
              <el-autocomplete
                class="popInput"
                v-model="appointment.operation_name"
                :fetch-suggestions="operationnamelist"
                placeholder="请输入内容"
                @blur="saveSuggesion(6)"
                @focus="updateLocal(6)"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手术部位">
              <!-- <el-input v-model="appointment.operation_position" placeholder="---选择检查部位---"></el-input> -->
              <el-cascader
                class="operationPosition"
                placeholder="---选择检查部位---"
                v-model="appointment.operation_position_new"
                :options="positionOption"
                :props="{ multiple: true, checkStrictly: false }"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="高危因素">
              <el-select v-model="appointment.high_risk_factor" size="small">
                <el-option
                  v-for="item in heightRisk"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
          <el-col :span="8">
            <el-form-item label="首诊医生">
              <el-autocomplete
                class="popInput"
                v-model="appointment.sign_doctor"
                :fetch-suggestions="signdoctorlist"
                placeholder="请输入内容"
                @blur="saveSuggesion(0)"
                @focus="updateLocal(0)"
              ></el-autocomplete>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-col :span="8">
              <el-form-item class="operation_date" label="手术日期">
                <el-date-picker
                  v-model="appointment.operation_date"
                  type="date"
                  @change="saveSuggesion(7)"
                  @focus="updateLocal(7)"
                  placeholder="选择日期"
                ></el-date-picker>
                <span v-show="hasOperationNum>0" class="now_operation">已预约{{hasOperationNum}}</span>
                <span v-show="true" class="now_operation">已预约:上午:{{hasOperationNum[0]}}  下午:{{hasOperationNum[1]}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="治疗时段">
                <el-select v-model="appointment.am_pm"   placeholder="--下拉选择时段--" >
                  <el-option label="上午" value="am"></el-option>
                  <el-option label="下午" value="pm"></el-option>
                </el-select>  
                <!-- <span v-show="hasOperationNum>0" class="now_operation">已预约{{hasOperationNum}}</span>             -->
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item label="手术地点">
                <el-autocomplete
                  class="popInput"
                  v-model="appointment.operation_place"
                  :fetch-suggestions="operationplacelist"
                  placeholder="请输入内容"
                  @blur="saveSuggesion(1)"
                  @focus="updateLocal(1)"
                ></el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="备注信息">
                <el-autocomplete
                  class="popInput"
                  v-model="appointment.note"
                  :fetch-suggestions="operationnotelist"
                  placeholder="请输入内容"
                  @blur="saveSuggesion(8)"
                  @focus="updateLocal(8)"
                ></el-autocomplete>
              </el-form-item>
            </el-col>

          </el-col>
          <!-- <el-col :span="8">
          </el-col>-->
          <br />
          <el-col :span="4">
            <el-form-item label="手术医生">
              <el-autocomplete
                class="popInput"
                v-model="appointment.operation_doctor"
                :fetch-suggestions="operationdoctorlist"
                placeholder="请输入内容"
                @blur="saveSuggesion(2)"
                @focus="updateLocal(2)"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="手术助理1">
              <el-autocomplete
                class="popInput"
                v-model="appointment.assistant1"
                :fetch-suggestions="assistant1list"
                placeholder="请输入内容"
                @blur="saveSuggesion(3)"
                @focus="updateLocal(3)"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="手术助理2">
              <el-autocomplete
                class="popInput"
                v-model="appointment.assistant2"
                :fetch-suggestions="assistant2list"
                placeholder="请输入内容"
                @blur="saveSuggesion(4)"
                @focus="updateLocal(4)"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="手术费用">
              <!-- <el-input v-model="appointment.operation_fee" placeholder="请输入"></el-input> -->
              <el-autocomplete
                type="text"
                class="popInput"
                v-model="appointment.operation_fee"
                :fetch-suggestions="operationfeelist"
                placeholder="请输入内容"
                @blur="saveSuggesion(5)"
                @focus="updateLocal(5)"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="8" class="btnBottom">
            <button
              @click.prevent="addOperation"
              class="btn iconfont leftItemSubmit btn_newpatient"
              style="padding: 0"
              :disabled="hasMutate"
              :class="{'hasDIsabled':hasMutate}"
            >确定</button>
            <button
              @click.prevent="printConsent()"
              class="btn iconfont leftItemSubmit"
              style="padding: 0"
            >知情同意书1</button>
            <button
              class="btn iconfont leftItemSubmit"
              style="padding: 0"
              @click.prevent="printConsent2()"
            >知情同意书2</button>
          </el-col>
        </el-form>
        <iframe hidden ref="iframePDF"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import addOperation from "../gql/addOperation.gql";
import setOperation from "../gql/setOperation.gql";
import getOperationData from "../gql/getOperationData.gql";
import operationByPatientDate from "../gql/operationByPatientDate.gql";
import operationNumByDate from "../gql/operationNumByDate.gql";
import gql from "graphql-tag";
import moment from "moment";
import position from "../race.js";
import saveLocal from "../utils/saveOperations";
import printReportConsent from "../utils/printReportConsent.js";
let regData = /[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/;
export default {
  name: "electiveOperation",
  data() {
    return {
      appointment: {
        patient_id: "",
        doctor_id: "",
        operation_name: "",
        operation_position_new: "",
        high_risk_factor: "",
        operation_date: "",
        operation_place: "",
        sign_doctor: "",
        operation_doctor: "",
        assistant1: "",
        assistant2: "",
        operation_fee: "",
        operation_status: "预约",
        record_person: "",
        operation_releinfo_id: "",
        am_pm:"",
        note:""
      },
      heightRisk: [
        { value: "手术部位", index: 0 },
        { value: "易损伤神经", index: 1 },
        { value: "血管", index: 3 }
      ],
      hasMutate: false, // 已经完成预约
      positionOption: [],
      newPosition: "",
      resetOperationDate: "",
      hasOperationNum: [0,0], // 当前已完成预约数量,上午和下午
    };
  },
  mixins: [saveLocal, printReportConsent],
  created() {
    // console.log(position.position.noDistinguish)
    // console.log( Object.keys(position.position.noDistinguish))
    let positionArray = position.position.noDistinguish;
    let newPositionArray = [];
    for (const A in positionArray) {
      if (positionArray.hasOwnProperty(A)) {
        let obj = {};
        obj.value = A;
        obj.label = A;
        obj.children = [];

        for (let i = 0; i < positionArray[A].length; i++) {
          let objChildren = {};
          objChildren.value = positionArray[A][i];
          objChildren.label = positionArray[A][i];
          obj.children.push(objChildren);
        }
        newPositionArray.push(obj);
      }
    }
    // console.log(newPositionArray)
    this.positionOption = newPositionArray;
  },
  computed: {
    patient_id() {
      return this.$store.state.operationPatientId;
    },
    opearClick() {
      return this.$store.state.operationClearClick;
    },
    editObjId() {
      return this.$store.state.editObjId;
    },
    operationElectiveId() {
      return Number(this.$store.state.operationElectiveId);
    },
    editOperation() {
      return this.$store.state.editOperation;
    },
    operationRelevantId() {
      return this.$store.state.operationRelevantId;
    }
  },
  mounted() {
    // console.log("mounted electiveOperation.vue, this.opearClick:",this.opearClick);
    if (this.opearClick) {
      // console.log("mounted electiveOperation.vue, goto reset");
      this.reset();
    }
  },
  watch: {
    "appointment.operation_position_new"(newVal) {
      if (newVal) {
 
        let newString = [];
        for (let i = 0; i < newVal.length; i++) {
          newString.push(newVal[i].join("-"));
        }
        this.newPosition = newString.join(",");
      } else {
        this.newPosition = "";
      }
    },
    "appointment.operation_fee"(newVal) {
      if (newVal <= 0) {
        this.$set(this.appointment, "operation_fee", "");
      }
    },
    // 如果清除被激活，进行reset.
    'opearClick'(newVal,oldVal) {
      // console.log("opearClick changed, newVal  and oldVal:",newVal,oldVal);
      if (newVal) {
        // console.log("opearClick changed, goto reset() ");
        this.reset();
      }
    },
    // added by zdh for debug
    'operationElectiveId'(newVal,oldVal) {
      // console.log("operationElectiveId changed, newVal and oldVal:",newVal,oldVal);
    },
    // 如果预约登记日期变更，自动更新该日期当天已经预约的数量
    async 'appointment.operation_date'(newVal) {
      if (newVal) {
        await this.operationNumByDate(newVal);
      } else {
        this.hasOperationNum = [0,0];
      }
    }
  },
  methods: {
    async reset() {
      this.appointment = {
        patient_id: "",
        doctor_id: "",
        operation_name: "",
        operation_position_new: "",
        high_risk_factor: "",
        operation_date: "",
        operation_place: "",
        sign_doctor: "",
        operation_doctor: "",
        assistant1: "",
        assistant2: "",
        operation_fee: "",
        operation_status: "预约",
        record_person: "",
        operation_releinfo_id: "",
        am_pm:"",
        note:""
      };
      this.hasMutate = false;
      this.resetOperationDate = "";
      this.hasOperationNum = [0,0];
      this.$store.commit("setoperationFormElectiveStatus", true);

      // console.log("In reset, operationElectiveId and editOperation:",this.operationElectiveId, this.editOperation);
      // 如果预约ID不为0及手术编辑为true，获取相应ID的登记数据
      if (this.operationElectiveId && this.editOperation) {
        this.resetOperationDate = "";
        // console.log("In reset, goto getOperation， operationElectiveId:", this.operationElectiveId);
        await this.getOperation();
      }
    },
    // 获取某预约ID（operationElectiveId）对应的数据
    async getOperation() {
      try {
        let res = await this.$apollo.query({
          query: getOperationData,
          variables: {
            id: this.operationElectiveId
          },
          fetchPolicy: "no-cache"
        });
        let newData = res.data.operation;
        // console.log("In getOpreration, operationElectiveId:",this.operationElectiveId);
        // console.log("In getOpreration, getOperationData:",newData);

        if (newData.operation_position) {
          let newArray1 = newData.operation_position.split(",");
          let newObj = [];
          for (let i = 0; i < newArray1.length; i++) {
            newObj.push(newArray1[i].split("-"));
          }
          this.appointment = newData;
          this.$set(this.appointment, "operation_position_new", newObj);
        } else {
          this.appointment = newData;
          this.$set(this.appointment, "operation_position_new", "");
        }
        this.$set(
          this.appointment,
          "operation_fee",
          `${newData.operation_fee * 0.01}`
        );
        this.resetOperationDate = moment(newData.operation_date).format(
          "YYYY-MM-DD"
        );
      } catch (error) {
        console.log(error);
      }
    },
    // 新增或者修改登记；必选项：operation_date，am_pm
    async addOperation() {
      if (this.patient_id && this.$store.state.operationRelevantId) {

        // console.log("In addOperation, appointment:",this.appointment);

        if (this.appointment.operation_date  && this.appointment.am_pm) {
          let isbofore = moment(this.appointment.operation_date).isAfter(
            moment().add(-1, "days")
          );
          // console.log("In addOperation,  isbefore:",isbofore);
          // console.log("In addOperation,  operationElectiveId:",this.operationElectiveId);
          if (!isbofore) {
            if (this.operationElectiveId) {
              this.hasMutate = true;
              await this.setOperation();
            } else {
              this.$message.error("无法预约过去时间");
            }
          } else {
            this.hasMutate = true;
            // console.log("In addOperation, this.operationElectiveId:",this.operationElectiveId);
            if (this.operationElectiveId) { 
              // console.log("In addOperation, goto branch 1 setOperation") ;         
              await this.setOperation();
            } else {
              // console.log("In addOperation, goto branch 2 mutateOperation");   
              await this.mutateOperation();
            }
          }
        } else {
          this.$message.error("请先选择预约日期及时段");
        }
      } else {
        this.$message.error("请先添加患者信息和相关信息");
      }
    },
    async operationByPatientDate() {
      try {
        let res = await this.$apollo.query({
          query: operationByPatientDate,
          variables: {
            operation_date: this.appointment.operation_date
              ? moment(this.appointment.operation_date).format("YYYY-MM-DD") +
                " 17:00:00"
              : '"1000-01-01 00:00:00"',
            patient_id: this.patient_id
          },
          fetchPolicy: "no-cache"
        });
        // console.log(res.data.operationByPatientDate);
        return res.data.operationByPatientDate;
      } catch (error) {
        this.$message.error("请检查网络");
        return true;
      }
    },
    // 获取某个日期当天已经预约的数量
    async operationNumByDate(data) {
      try {
        let res = await this.$apollo.query({
          query: operationNumByDate,
          variables: {
            operation_date: moment(data).format("YYYY-MM-DD") + " 17:00:00",
          },
          fetchPolicy: "no-cache"
        });
        // console.log("In operationNumByDate,date is:",moment(data).format("YYYY-MM-DD") + " 17:00:00", ",  res.data:",res.data)
        this.hasOperationNum = res.data.operationNumByDate;

      } catch (error) {
        this.$message.error("请检查网络");
        this.hasOperationNum = [0,0];
      }
    },
    async mutateOperation() {
      try {
        let hasOperaton = await this.operationByPatientDate();
        if (hasOperaton) {
          this.$confirm(
            `该患者已预约过当天的手术，是否继续?`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          ).then(async () => {
            await this.mutateOperation2();
          }).catch(() => {
              this.hasMutate = false;
              // console.log('取消');
            });
        } else {
          await this.mutateOperation2();
        }
      } catch (error) {
        this.$message.error("请检查网络");
        console.log(error)
      }
    },
    async mutateOperation2() {
      try {
        if (!this.$store.state.doctorDitail.id) {
          await this.getMe();
        }
        let res = await this.$apollo.mutate({
          mutation: addOperation,
          variables: {
            patient_id: this.patient_id,
            doctor_id: this.$store.state.doctorDitail.id,
            operation_name: this.appointment.operation_name,
            operation_position: this.appointment.operation_position_new
              ? this.newPosition
              : "",
            high_risk_factor: this.appointment.high_risk_factor,
            operation_date: this.appointment.operation_date
              ? moment(this.appointment.operation_date).format("YYYY-MM-DD") + " 17:00:00"
              : '"1000-01-01 00:00:00"',
            operation_place: this.appointment.operation_place,
            sign_doctor: this.appointment.sign_doctor,
            operation_doctor: this.appointment.operation_doctor,
            assistant1: this.appointment.assistant1,
            assistant2: this.appointment.assistant2,
            operation_fee: this.appointment.operation_fee
              ? Number(this.appointment.operation_fee) * 100
              : 0,
            operation_status: "预约",
            record_person: this.$store.state.doctorDitail.realname,
            operation_releinfo_id: this.$store.state.operationRelevantId,
            am_pm: this.appointment.am_pm,
            note: this.appointment.note
          }
        });

        this.$message.success("手术已预约成功");
        // this.$store.commit("sethasNewElective", true);
        this.$root.$emit("refreshOperationList");
        await this.operationNumByDate(this.appointment.operation_date);
      } catch (error) {
        if (error.message.split(":")[1] === " Failed to fetch") {
          this.$message.error("请检查网络");
          this.hasMutate = false;
          return;
        }
        if (error.message.split(":")[1] === " 未配置手术预约人数") {
          this.$message.error("未配置预约人数，无法预约");
          this.hasMutate = false;
          return;
        }

        // 后台判断当日无可预约资源后，寻找新的可预约日期：
        // 消息格式约定：available 为返回的消息内容，其中newdate格式为"YEAR-MH-DY", am_pm为string；约定两个数据以@@相连
        // available = newdate + "@@" + tmp_time;

        //if (regData.test(error.message.split(":")[1])) 
        if( error.message.split(":")[1].search("@@")!=-1){
           console.log(error.message);
           let newdate = error.message.split(":")[1].split("@@")[0];
           let new_am_pm = error.message.split(":")[1].split("@@")[1];
           let new_am_pm_mesg = new_am_pm=="am"?"上午":"下午";
          //  this.$message.error(error.message.split(":")[1]);
          this.$confirm(
            `当前日期已约满，可预约到${newdate} ${new_am_pm_mesg}是否继续?`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          )
            .then(async () => {
              //更新日期和时段
              this.appointment.operation_date = moment(
                newdate
              ).format("YYYY-MM-DD");
              this.appointment.am_pm = new_am_pm;
              //重新提起新建登记请求
              await this.mutateOperation();
              // TODO ,参数是否正确？？？？
              this.saveSuggesion(7);   
            })
            .catch(() => {
              this.hasMutate = false;
              // console.log('取消');
            });
        } else {
          console.log(error);
          this.$message.error(error.message.split(":")[1]);
          this.hasMutate = false;
        }

        // 2024-0630 注释
        // if (regData.test(error.message.split(":")[1])) {
        //   //  this.$message.error(error.message.split(":")[1]);
        //   this.$confirm(
        //     `当前日期已约满，可预约到${error.message.split(":")[1]}是否继续?`,
        //     "提示",
        //     {
        //       confirmButtonText: "确定",
        //       cancelButtonText: "取消",
        //       type: "warning"
        //     }
        //   )
        //     .then(async () => {
        //       this.appointment.operation_date = moment(
        //         error.message.split(":")[1]
        //       ).format("YYYY-MM-DD");
        //       await this.mutateOperation();
        //       this.saveSuggesion(7);
        //     })
        //     .catch(() => {
        //       this.hasMutate = false;
        //       // console.log('取消');
        //     });
        // } else {
        //   console.log(error);
        //   this.$message.error(error.message.split(":")[1]);
        //   this.hasMutate = false;
        // }
      }
    },
    async setOperation() {
      try {
        if (!this.$store.state.doctorDitail.id) {
          await this.getMe();
        }
        let query = {};
        if (
          this.resetOperationDate ===
          moment(this.appointment.operation_date).format("YYYY-MM-DD")
        ) {
          query = {
            id: this.operationElectiveId,
            patient_id: this.patient_id,
            doctor_id: this.$store.state.doctorDitail.id,
            operation_name: this.appointment.operation_name,
            operation_position: this.appointment.operation_position_new
              ? this.newPosition
              : "",
            high_risk_factor: this.appointment.high_risk_factor,
            operation_place: this.appointment.operation_place,
            sign_doctor: this.appointment.sign_doctor,
            operation_doctor: this.appointment.operation_doctor,
            assistant1: this.appointment.assistant1,
            assistant2: this.appointment.assistant2,
            operation_fee: this.appointment.operation_fee
              ? Number(this.appointment.operation_fee) * 100
              : 0,
            // operation_status: "预约",
            record_person: this.$store.state.doctorDitail.realname,
            operation_releinfo_id: this.$store.state.operationRelevantId,
            am_pm: this.appointment.am_pm,
            note: this.appointment.note
          };
        } else {
          let isbofore = moment(this.appointment.operation_date).isAfter(
            moment().add(-1, "days")
          );
          if (!isbofore) {
            this.$message.error("无法修改为过去时间");
            this.hasMutate = false;
            return;
          } else {
            query = {
              id: this.operationElectiveId,
              patient_id: this.patient_id,
              doctor_id: this.$store.state.doctorDitail.id,
              operation_name: this.appointment.operation_name,
              operation_position: this.appointment.operation_position_new
                ? this.newPosition
                : "",
              high_risk_factor: this.appointment.high_risk_factor,
              operation_date: this.appointment.operation_date
                ? moment(this.appointment.operation_date).format("YYYY-MM-DD") +
                  " 17:00:00"
                : '"1000-01-01 00:00:00"',
              operation_place: this.appointment.operation_place,
              sign_doctor: this.appointment.sign_doctor,
              operation_doctor: this.appointment.operation_doctor,
              assistant1: this.appointment.assistant1,
              assistant2: this.appointment.assistant2,
              operation_fee: this.appointment.operation_fee
                ? Number(this.appointment.operation_fee) * 100
                : 0,
              operation_status: "预约",
              record_person: this.$store.state.doctorDitail.realname,
              operation_releinfo_id: this.$store.state.operationRelevantId,
              am_pm: this.appointment.am_pm,
              note: this.appointment.note
            };
          }
        }
        let res = await this.$apollo.mutate({
          mutation: setOperation,
          variables: query
        });
        this.$message.success("数据已修改");
        this.hasMutate = true;
        // this.$store.commit("sethasNewElective", true);
        this.$root.$emit("refreshOperationList");
        await this.operationNumByDate(this.appointment.operation_date);
      } catch (error) {
        if (error.message.split(":")[1] === " Failed to fetch") {
          this.$message.error("请检查网络");
          this.hasMutate = false;
          return;
        }
        if (error.message.split(":")[1] === " 未配置手术预约人数") {
          this.$message.error("未配置预约人数，无法预约");
          this.hasMutate = false;
          return;
        }

        // 旧的方式为判断返回的信息内是否匹配日期的正则表达式
        //if (regData.test(error.message.split(":")[1])) 

        // 后台判断当日无可预约资源后，寻找新的可预约日期：
        // 消息格式约定：available 为返回的消息内容，其中newdate格式为"YEAR-MH-DY", am_pm为string；约定两个数据以@@相连
        // available = newdate + "@@" + tmp_time;
        
        //if (regData.test(error.message.split(":")[1])) 
        if( error.message.split(":")[1].search("@@")!=-1){
           console.log(error.message);
           let newdate = error.message.split(":")[1].split("@@")[0];
           let new_am_pm = error.message.split(":")[1].split("@@")[1];
           let new_am_pm_mesg = new_am_pm=="am"?"上午":"下午";
          //  this.$message.error(error.message.split(":")[1]);
          this.$confirm(
            `当前日期已约满，可预约到${newdate} ${new_am_pm_mesg}是否继续?`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          ).then(async () => {
              //更新日期和时段
              this.appointment.operation_date = moment(
                newdate
              ).format("YYYY-MM-DD");
              this.appointment.am_pm = new_am_pm;
              //重新提起新建登记请求
              await this.mutateOperation();
              // TODO ,参数是否正确？？？？
              this.saveSuggesion(7);   
            }).catch(() => {
              this.hasMutate = false;
              // console.log('取消');
            });
        } else {
          console.log(error);
          this.$message.error(error.message.split(":")[1]);
          this.hasMutate = false;
        }


        // if (regData.test(error.message.split(":")[1])) {
        //   //  this.$message.error(error.message.split(":")[1]);
        //   this.$confirm(
        //     `当前日期已约满，可预约到${error.message.split(":")[1]}是否继续?`,
        //     "提示",
        //     {
        //       confirmButtonText: "确定",
        //       cancelButtonText: "取消",
        //       type: "warning"
        //     }
        //   )
        //     .then(async () => {
        //       this.appointment.operation_date = moment(
        //         error.message.split(":")[1]
        //       ).format("YYYY-MM-DD");
        //       await this.setOperation();
        //       this.saveSuggesion(7);
        //     })
        //     .catch(() => {
        //       console.log("取消");
        //       this.hasMutate = false;
        //     });
        // } else {
        //   console.log(error);
        //   this.$message.error(error.message.split(":")[1]);
        //   this.hasMutate = false;
        // }
      }
    },
    async getMe() {
      try {
        let res = await this.$apollo.query({
          query: gql`
            {
              me {
                id
                realname
              }
            }
          `
        });
        let realname = res.data.me.realname;
        this.$store.commit("setMe", realname);
        localStorage.setItem("me", realname);
        this.$store.commit("setdoctorDitail", {
          id: res.data.me.id,
          realname: res.data.me.realname ? res.data.me.realname : ""
        });
      } catch (error) {
        this.$message.error("请检查网络后重试");
      }
    }
  }
};
</script>
<style lang="less">
.electiveOperation {
  .el-form-item__label {
    color: black;
    font-weight: 600;
  }
  .el-select,
  .el-cascader,
  .el-form-item__content {
    width: 100%;
  }
  .el-form-item {
    width: 100% !important;
    display: flex;
    margin-top: 10px;
    padding-left: 24px;
    box-sizing: border-box;
    margin-bottom: 0;
  }
  .el-form-item__content {
    flex: 1;
  }
  .el-input input {
    // min-height: 36px !important;
    height: 36px !important;
    width: 100%;
  }
  .el-cascader__tags {
    height: 32px !important;
    overflow-y: auto;
    padding-top: 2px;
    // margin: 1px 0 !important;
    box-sizing: border-box !important;
  }
  .el-date-editor {
    width: 100%;
  }
}
</style>
<style lang="less">
.electiveOperation {
  .line {
    width: 100%;
    height: 2px;
    background: #4ea3c0;
  }
  .nav {
    .title {
      display: flex;
      color: #4ea3c0;
      // height: 40px;
      line-height: 45px;
      i {
        text-indent: 50px;
        font-size: 30px;
      }
      p {
        text-indent: 10px;
        font-size: 18px;
      }
    }
  }
  .main {
    padding: 0 30px;
    box-sizing: border-box;
    .leftItemSubmit {
      height: 40px;
    }
    .btnBottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 55px;
      padding-left: 24px;
      box-sizing: border-box;
    }
  }
  .hasDIsabled {
    background: gray !important;
    cursor: not-allowed;
  }
  .popInput {
    width: 100%;
  }
  .operation_date{
    position: relative;
    .now_operation{
      position: absolute;
      right: 30px;
      background: #67c23a;
      color: white;
      border-radius: 4px;
      padding: 0 4px;
    }
  }
}
</style>
